export const locale = {
    lang: 'es',
    data: {
        MENU: {
            DASHBOARD: 'Panel',
            PROPIETORS: 'Propietarios',
            PROPERTIES: 'Propiedades',
            UNIT:'Unidades',
            TENANTS: 'Clientes',
            LEASES: 'Contratos de renta',
            COMPANY_ANNEX: 'Anexos de empresa',
            UTILITIES: 'Utilidades',
            INVOICES: 'Facturas',
            PAYMENTS: 'Pagos',
            EVICTION_NOTICE: 'Aviso de Desalojo',
            NOTIFICATIONS: 'Notifications',
            ORDERS: 'Ordenes',
            CLIENTS: 'Clientes',
            PRODUCTS: 'Productos',
            BRANCHES: 'Sucursales',
            INVENTORIES: 'Inventarios',
            PROVIDERS: 'Proveedores',
            USERS: 'Usuarios',
            ROLES: 'Roles',
            CONFIGURATIONS: 'Configuraciones',
            PURCHASES: 'Compras',
            RECEPTIONS: 'Recepciones',
            REMISSIONS: 'Remisiones',
            EXPENSES: 'Gastos',
            COMPANY_ANNEX_INVOICES: 'Facturas de empresa'
        }
    }
}
